export default __webpack_public_path__ + "static/cafe_36039-aabfe30585914cc4bc191d4913a57686.png";